import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=6bb2d1e0&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"
import style0 from "./LogoutView.vue?vue&type=style&index=0&id=6bb2d1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2d1e0",
  null
  
)

export default component.exports